(function () {
  if (window.ArcheXxlDelivery) return;
  var deadline = Date.UTC(2026, 10, 20);
  function days(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(now || new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return Math.round((deadline - Date.UTC(+parts.year, +parts.month - 1, +parts.day)) / 86400000);
  }
  function text(now, english) {
    var n = days(now);
    if (n < 0) return english ? 'Pre-order — delivery date being confirmed.' : 'Předobjednávka — termín dodání ověřujeme.';
    if (!n) return english ? 'Pre-order — delivery expected this week.' : 'Předobjednávka — předpokládané dodání tento týden.';
    var weeks = Math.ceil(n / 7);
    return english ? 'Pre-order — delivery in ' + weeks + (weeks === 1 ? ' week.' : ' weeks.') :
      'Předobjednávka — dodání za ' + weeks + (weeks === 1 ? ' týden.' : weeks < 5 ? ' týdny.' : ' týdnů.');
  }
  window.ArcheXxlDelivery = { days: days, text: text, date: '20. 11. 2026' };
  function update() {
    document.querySelectorAll('[data-xxl-delivery]').forEach(function (node) {
      node.textContent = text(null, document.documentElement.lang.indexOf('en') === 0);
    });
  }
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('visibilitychange', update);
  setInterval(update, 30000);
})();
